import { render, staticRenderFns } from "./FindPassword.vue?vue&type=template&id=4dd24728&"
import script from "./FindPassword.vue?vue&type=script&lang=ts&"
export * from "./FindPassword.vue?vue&type=script&lang=ts&"
import style0 from "./FindPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports